import React, {useState, useContext} from "react";
import { Link } from "react-router-dom";
import AsyncJsonLoader from "../auth/AsyncJsonLoader";
import api from "../../js/utils/async/api";
import { Header } from "../components/Header";
import CredentialsContext from "../contexts/CredentialsContext";

import "../css/user-list.css";

export default function UsersList(){

  const [flag, setFlag] = useState(false);
  const {credentials, setCredentials} = useContext(CredentialsContext);

  
  return (<>
    <Header backMode="/admin"/>
    <AsyncJsonLoader flag={flag} path="/api/users/" render={function(users){

      const deleteUser = async (user) => {
        if(window.confirm("Вы уверены, что хотите удалить пользователя " + user.username + "?")){
          try {
            const result = await api.users.delete(user.username, credentials.token); 
            if (result === "ok") {
              window.alert("Пользователь удален");
              setFlag(!flag);
            }
            else 
              throw new Error();
          } catch (error) {console.log(error)}
        } else {
          return 0;
        }
      };

      return <div className="container">
        <table className="user-list">
          <thead>
            <tr>
              <th>ID</th>
              <th>Имя</th>
              <th>Роль</th>
              <th>Последняя активность</th>
            </tr>
          </thead>
          <tbody>
            
            {
              users.map(function(user, index){
                return (
                  <tr key={index}>
                    <td>{user.id}</td>
                    <td>{user.username}</td>
                    <td>{user.usertype}</td>
                    <td>{user.last_activity}</td>
                    <td>{<Link className="btn btn-default" to="/edit" state={{user: user}}>Изменить</Link>}</td>
                    <td>{<div className="btn btn-default" onClick={() => deleteUser(user)}>Удалить</div>}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    }}/>
    </>
  )
}